import { module as modujs } from "modujs";
import { gsap } from "gsap";

export default class extends modujs {
	constructor(m) {
		super(m);

		this.events = {
			click: {
				next: "changeIndex",
				prev: "changeIndex",
			},
		};
	}

	init() {
		this.$content = this.$("content");
		this.$image = this.$("image");
		this.$navigation = this.$("navigation");
		this.$progressBar = this.$("progress-bar")[0];
		this.$progress = this.$("progress")[0];

		// Set initial state
		this.currentIndex = 0;
		this.totalItems = this.$content.length;

		// Initialize progress tracking
		this.progressBarWidth = this.$progressBar.offsetWidth;
		this.stepWidth = this.progressBarWidth / this.totalItems;
		this.$progress.style.width = `${this.stepWidth}px`;
		this.updateProgressWidth();

		// Show the first item, hide others
		this.fadeInOut();
	}

	changeIndex(e) {
		// Determine if next or prev was clicked
		const isNext = e.currentTarget.classList.contains("-right");

		// Update the current index
		if (isNext) {
			this.currentIndex = (this.currentIndex + 1) % this.totalItems;
		} else {
			this.currentIndex = (this.currentIndex - 1 + this.totalItems) % this.totalItems;
		}

		this.updateProgressWidth();
		this.fadeInOut();
		this.progress();
	}

	fadeInOut() {
		// Remove active class from all items
		this.$content.forEach((content) => content.classList.remove("-active"));
		this.$image.forEach((image) => image.classList.remove("-active"));

		// Add active class to current items
		this.$content[this.currentIndex].classList.add("-active");
		this.$image[this.currentIndex].classList.add("-active");
	}

	// New method to update progress width
	updateProgressWidth() {
		this.progressCursorWidth = this.stepWidth * (this.currentIndex + 1);
	}

	progress() {
		gsap.to(this.$progress, {
			width: `${this.progressCursorWidth}px`,
			duration: 0.5,
			ease: "power2.inOut",
		});
	}

	destroy() {}
}
